import { APIcallerv2 } from './APIcaller';

const addInventoryListTemplateMappings = async (
  inventoryListTemplateIds,
  supplierProductIds = [],
  entityIds = [],
) =>
  APIcallerv2.apiPost('/inventory-list-templates/mappings', {
    inventoryListTemplateIds,
    supplierProductIds,
    entityIds,
  });

const copyInventoryListTemplateParams = async (sourceILTId, targetILTIds) =>
  APIcallerv2.apiPost('/inventory-list-templates/clone-mappings', {
    sourceILTId,
    targetILTIds,
  });

export default {
  addInventoryListTemplateMappings,
  copyInventoryListTemplateParams,
};
